
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"115","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_24409_149021)"}},[_c('path',{attrs:{"d":"M109.396 4.945H53.731c-3.074 0-5.567 2.469-5.567 5.511v32.732c0 3.042 2.493 5.51 5.567 5.51h22.266L74.14 54.21h-8.35c-1.53 0-2.783 1.24-2.783 2.756 0 1.515 1.253 2.755 2.783 2.755h31.544c1.537 0 2.784-1.234 2.784-2.755s-1.247-2.756-2.784-2.756h-8.35L87.13 48.7h22.266c3.073 0 5.567-2.469 5.567-5.511V10.456c0-3.042-2.494-5.51-5.567-5.51zm1 38.406H52.731V9.456h57.665v33.895z","fill":"#D3D7E1"}})]),_c('path',{attrs:{"d":"M11.607 30.017h35.7v18.3h-35.7v-18.3zm-2.004-8.064c-3.381 0-6.416 2.558-6.416 6.06v22.308c0 3.502 3.035 6.06 6.416 6.06h39.708c3.381 0 6.416-2.558 6.416-6.06V28.013c0-3.502-3.035-6.06-6.416-6.06H9.603z","fill":"#D3D7E1","stroke":"#fff","stroke-width":"4.008"}}),_c('rect',{attrs:{"x":".779","y":"54.375","width":"57.355","height":"5.344","rx":"2.672","fill":"#D3D7E1"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_24409_149021"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(48.164 .938)","d":"M0 0h66.799v58.783H0z"}})])])])
          )
        }
      }
    